import * as React from "react"

// Styles
const partialPatreonStyles = {
  textAlign: "center",
}

// Markup
const PartialPatreonComponent = () => {
  return (
    <div style={partialPatreonStyles}>
      <p><a href="https://www.patreon.com/v4ex/">Join the club, </a>get certificate as successful investor.</p>
    </div>
  )
}


export default PartialPatreonComponent
